<template>
  <section class="colored section">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(validateBeforeSubmit)">
        <h2 class="title">5 {{ $t('Documentos') }}</h2>
        <table class="table is-striped is-narrow is-hoverable is-fullwidth">
          <file-input
            :rowClass="getUploadRowClass(formData.proposal.status)"
            icon="upload"
            :text="$t('Propuesta ciega')"
            accept="application/pdf"
            v-model="formData.proposal.url"
          >
            <td>
              <div class="buttons">
                <b-button
                  @click="callPostNewOnboardReviewRequest('proposal')"
                  type="is-info"
                  icon-right="send"
                />
                <b-button
                  v-if="
                    formData.proposal.url &&
                      savedFormData.proposal.url != formData.proposal.url
                  "
                  @click="
                    callPostRespondOnboardReviewRequest('proposal', 'accepted')
                  "
                  type="is-success"
                  icon-right="check"
                />
              </div>
            </td>
          </file-input>

          <file-input
            :rowClass="getUploadRowClass(formData.contractDraft.status)"
            icon="upload"
            :text="$t('Borrador de contrato')"
            accept="application/pdf"
            v-model="formData.contractDraft.url"
          >
            <td>
              <div class="buttons">
                <b-button
                  @click="callPostNewOnboardReviewRequest('contract_draft')"
                  type="is-info"
                  icon-right="send"
                />
                <b-button
                  v-if="
                    formData.contractDraft.url &&
                      savedFormData.contractDraft.url !=
                        formData.contractDraft.url
                  "
                  @click="
                    callPostRespondOnboardReviewRequest(
                      'contract_draft',
                      'accepted'
                    )
                  "
                  type="is-success"
                  icon-right="check"
                />
              </div>
            </td>
          </file-input>

          <file-input
            icon="upload"
            :rowClass="getUploadRowClass(formData.contract.status)"
            :text="$t('Contrato definitivo')"
            accept="application/pdf"
            v-model="formData.contract.url"
          >
            <td>
              <div class="buttons">
                <b-button
                  @click="callPostRequestContractSignature"
                  type="is-info"
                  icon-right="send"
                />
              </div>
            </td>
          </file-input>
          <file-input
            :rowClass="getUploadRowClass(formData.invoice.status)"
            icon="upload"
            :text="$t('Factura')"
            accept="application/pdf"
            v-model="formData.invoice.url"
          >
            <td>
              <div class="buttons">
                <b-button
                  @click="callPostSendRequestInvoice"
                  type="is-info"
                  icon-right="send"
                />
              </div>
            </td>
          </file-input>
          <tr>
            <td>
              {{ $t('Importe') }}
            </td>
            <td>
              <b-field>
                <b-input
                  style="max-width: 200px;"
                  v-model="formData.paymentAmount"
                  placeholder="€"
                  size="is-small"
                ></b-input>
              </b-field>
            </td>
          </tr>
        </table>

        <div class="has-text-centered">
          <b-button size="is-large" native-type="submit" type="is-primary">
            {{ $t('Guardar') }}
          </b-button>
        </div>
      </form>
    </ValidationObserver>
  </section>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import BulmaS3UploadInput from '@/components/common/BulmaS3UploadInputSingle'

export default {
  components: {
    ValidationObserver,
    FileInput: BulmaS3UploadInput
  },
  props: {
    documents: {
      type: Object,
      default: function() {
        return {
          proposal: {
            url: null,
            status: null
          },
          contractDraft: {
            url: null,
            status: null
          },
          contract: {
            url: null,
            status: null
          },
          invoice: {
            url: null,
            status: null
          },
          paymentAmount: null
        }
      }
    }
  },
  watch: {
    documents: function(val) {
      this.formData = val
    }
  },
  data() {
    return {
      formData: null,
      savedFormData: null
    }
  },
  beforeMount() {
    this.formData = this.documents
    this.savedFormData = this.documents
  },
  methods: {
    validateBeforeSubmit() {
      this.$emit('formSubmit', { documents: this.formData })
    },
    getUploadRowClass(documentStatus) {
      if (!documentStatus) return 'default'
      const mapStatuses = {
        sent: 'info',
        accepted: 'success',
        declined: 'warning'
      }
      return mapStatuses[documentStatus]
    },
    callPostRequestContractSignature() {
      this.$emit('postRequestContractSignature')
    },
    callPostSendRequestInvoice() {
      this.$emit('postSendRequestInvoice', {
        url: this.formData.invoice.url.url
      })
    },
    callPostNewOnboardReviewRequest(documentType) {
      this.$emit('postNewOnboardReviewRequest', { documentType })
    },
    callPostRespondOnboardReviewRequest(documentType, response) {
      this.$emit('postRespondOnboardReviewRequest', { documentType, response })
    }
  }
}
</script>

<style scoped></style>
